import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { getTestIds } from '../../utils/TestIds';
import { Collapse } from '../Collapse';
import styles from './PasswordStrengthMeter.module.scss';
export const GetPasswordStrengthMeterTID = (parentTestId)=>getTestIds(parentTestId);
const STRENGTH_DISPLAYS = {
    weak: {
        width: '30%',
        label: 'Password is too weak - try making it longer and less predictable'
    },
    good: {
        width: '64%',
        label: 'Good to go'
    },
    strong: {
        width: '100%',
        label: 'Strong'
    }
};
function strengthLevelFromScore(score) {
    if (score >= 4) return 'strong';
    if (score >= 3) return 'good';
    return 'weak';
}
export const PasswordStrengthMeter = (param)=>{
    let { score, testId, labels } = param;
    var _ref, _ref1;
    const testIds = useMemo(()=>GetPasswordStrengthMeterTID(testId), [
        testId
    ]);
    const level = score !== null ? strengthLevelFromScore(score) : null;
    const baseDisplay = level ? STRENGTH_DISPLAYS[level] : null;
    const display = baseDisplay && level ? _object_spread_props(_object_spread({}, baseDisplay), {
        label: (_ref = labels === null || labels === void 0 ? void 0 : labels[level]) !== null && _ref !== void 0 ? _ref : baseDisplay.label
    }) : null;
    return /*#__PURE__*/ _jsx(Collapse, {
        in: score !== null,
        unmountOnExit: true,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.root,
            "data-testid": testIds.PasswordStrengthMeterTestIds.Root(),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.track,
                    "data-testid": testIds.PasswordStrengthMeterTestIds.Track(),
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "".concat(styles.fill, " ").concat(level ? styles[level] : ''),
                        style: {
                            width: (_ref1 = display === null || display === void 0 ? void 0 : display.width) !== null && _ref1 !== void 0 ? _ref1 : '0%'
                        },
                        "data-testid": testIds.PasswordStrengthMeterTestIds.Fill()
                    })
                }),
                display && /*#__PURE__*/ _jsx("span", {
                    className: styles.label,
                    "data-testid": testIds.PasswordStrengthMeterTestIds.Label(),
                    children: display.label
                })
            ]
        })
    });
};
